'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { useLastAuthenticationStrategy } from '@/app/(auth)/_hooks/use-last-authentication-strategy';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { AuthLastUsedButtonWrap } from '@/app/(auth)/_partials/auth-last-used-badge';
import { useSignIn } from '../_hooks/use-sign-in';
import { useSignInFlowStore } from '../_hooks/use-sign-in-flow-store';
export function SignInChooseStrategyControl() {
  const $ = _c(17);
  const {
    onPrepareEmailCodeFirstFactor,
    signIn
  } = useSignIn();
  const {
    trackSignInStrategySelected
  } = useAuthEvents();
  const lastAuthenticationStrategy = useLastAuthenticationStrategy();
  const identifier = useSignInFlowStore(_temp);
  const onChange = useSignInFlowStore(_temp2);
  let t0;
  if ($[0] !== identifier || $[1] !== signIn.supportedFirstFactors) {
    t0 = signIn.supportedFirstFactors?.some(_temp3) ?? identifier?.includes("@") ?? false;
    $[0] = identifier;
    $[1] = signIn.supportedFirstFactors;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hasEmailCode = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AuthCard.Header><AuthCard.Title>Join a Community Committed to Your Career Success</AuthCard.Title><AuthCard.Description>Access company Externships, build skills, and explore careers on your terms.</AuthCard.Description></AuthCard.Header>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== hasEmailCode || $[5] !== lastAuthenticationStrategy || $[6] !== onPrepareEmailCodeFirstFactor || $[7] !== trackSignInStrategySelected) {
    t2 = hasEmailCode ? <AuthLastUsedButtonWrap matchStrategy="email_code" strategy={lastAuthenticationStrategy}><Button className="w-full" onClick={() => {
        trackSignInStrategySelected("email_code");
        onPrepareEmailCodeFirstFactor().catch(_temp4);
      }} type="button">Email code</Button></AuthLastUsedButtonWrap> : null;
    $[4] = hasEmailCode;
    $[5] = lastAuthenticationStrategy;
    $[6] = onPrepareEmailCodeFirstFactor;
    $[7] = trackSignInStrategySelected;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <AuthCard.Content><div className="flex flex-col gap-3">{t2}</div></AuthCard.Content>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onChange || $[12] !== trackSignInStrategySelected) {
    t4 = <AuthCard.Footer><Button appearance="outlined" className="w-full" color="info" onClick={() => {
        trackSignInStrategySelected("password");
        onChange({
          firstFactorStrategy: "password",
          step: "verifications"
        });
      }} type="button">Return</Button></AuthCard.Footer>;
    $[11] = onChange;
    $[12] = trackSignInStrategySelected;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <AuthCard>{t1}{t3}{t4}</AuthCard>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp4() {}
function _temp3(f) {
  return f.strategy === "email_code";
}
function _temp2(s_0) {
  return s_0.onChange;
}
function _temp(s) {
  return s.identifier;
}